import { useLocation, useParams } from 'react-router-dom';

import { PieceCatalogDetail } from '@/features/piece-catalog/components/piece-catalog-detail';
import {
  catalogCategorySearch,
  catalogSearchFrom,
  pieceNameFromRouteParam,
} from '@/features/piece-catalog/lib/catalog-navigation';

import { ADMIN_CATALOG_PATH } from './catalog-paths';

const AdminCatalogPieceDetailPage = () => {
  // Defaulted rather than asserted: the route always carries the parameter.
  const { pieceName = '' } = useParams();
  const { state } = useLocation();

  return (
    <PieceCatalogDetail
      pieceName={pieceNameFromRouteParam(pieceName)}
      catalogPath={`${ADMIN_CATALOG_PATH}${catalogSearchFrom(state)}`}
      categoryPath={(category) =>
        `${ADMIN_CATALOG_PATH}${catalogCategorySearch(category)}`
      }
    />
  );
};

export default AdminCatalogPieceDetailPage;
